import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { getGuideBasicDetailsApi } from "../../api/candidate";
import WebUtils from "../../utils/WebUtils";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { ROLES } from "../../constants/UserRoles";
import PracticeMain from "../../components/orgAdmin/practice/PracticeMain";

function OrgAdminPractice() {
  const { jobGuideIdentifier } = useParams();
  const [searchParams] = useSearchParams();
  const industryId = searchParams.get("industryId");

  const [loading, setLoading] = useState(false);
  const [basicGuideDetails, setBasicGuideDetails] = useState(null);

  const getBasicGuideDetails = () => {
    let url = "";

    url = `${getGuideBasicDetailsApi}?jobGuideIdentifier=${jobGuideIdentifier}`;

    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setBasicGuideDetails(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (jobGuideIdentifier) getBasicGuideDetails();
  }, [jobGuideIdentifier]);
  return (
    <>
      {loading && <Loader />}

      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="preparationGuides" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="preparationGuides"
            userRole={ROLES.org_admin}
            newTitle={`Practice Guide (${
              basicGuideDetails?.jobTitle || "N/A"
            })`}
          />
          <div
            id="practice-container"
            className="py-[1.2rem] px-[0.8rem] lg:px-6 "
          >
            <PracticeMain />
          </div>
        </div>
      </div>
    </>
  );
}

export default OrgAdminPractice;
